export default class Move {
    constructor(targetIndex, direction) {
        this.targetIndex = targetIndex
        this.direction = direction
    }
}